import { useEffect, useState } from 'react';
import _ from 'lodash';
import { useNavigate, NavigateFunction } from 'react-router-dom';
import debug from '../../services/debug';

interface ContactIDRouteActionProps {
  contactidroute?: string | null;
  contact?: Record<string, unknown>;
  contacts?: { items?: { ContactID?: string }[] };
  handleGetContactIDRouteAction?: (
    contactidroute: string,
    navigate: NavigateFunction,
  ) => void;
  selectContact?: (
    contactId: string | undefined,
    navigate: NavigateFunction,
  ) => void;
}

function ContactIDRouteAction({
  contactidroute = null,
  contact = {},
  contacts = {},
  handleGetContactIDRouteAction = () => {},
  selectContact = () => {},
}: ContactIDRouteActionProps) {
  const navigate = useNavigate();
  const [getting, setGetting] = useState(false);
  const [selecting, setSelecting] = useState(false);
  useEffect(() => {
    if (contactidroute && contactidroute.length > 0) {
      if (!getting) {
        debug('ContactIDRouteAction get', contactidroute);
        setGetting(true);
        handleGetContactIDRouteAction(contactidroute, navigate);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contactidroute]);

  useEffect(() => {
    if (!selecting && (contacts?.items ?? []).length > 0) {
      setSelecting(true);
      const foundContact = contacts?.items?.[0];
      debug('ContactIDRouteAction select', foundContact?.ContactID);
      selectContact(foundContact?.ContactID, navigate);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contacts]);

  useEffect(() => {
    if (!_.isEmpty(contact)) {
      navigate('/dashboard');
    }
  }, [contact, navigate]);

  return null;
}

export default ContactIDRouteAction;
